import { Typography, Grid, Tooltip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const useStyles = makeStyles((theme) => ({
  label: {
    fontSize: "16px!important",
    color: '#373A45',
    fontWeight: "500 !important",
    fontFamily: '"GeneralSans" !important',
    marginBottom: '6px',
  },
  labelWrap: {
    marginBottom: 2,
  },
  asterisk: {
    color: 'red',
    marginLeft: '2px'
  },
}));
export default function KenTextLabel(props) {
  const classes = useStyles();
  const { label, required, optionalLabel, helperText, instruction, labelClassName } = props;

  return (
    <div className={classes.labelWrap}>
      <Grid container justify="space-between">
        <Grid item>
          {instruction && <Typography className={classes.label}>{instruction}</Typography>}
          <Typography className={labelClassName ? labelClassName : classes.label}>
            {label} {required ? <span className={classes.asterisk}>*</span> : ''}
            {helperText && (
              <span>
                <Tooltip title={helperText}>
                  <HelpOutlineIcon
                    sx={{
                      height: '12px !important',
                      width: '12px',
                      marginLeft: '3px',
                    }}
                  />
                </Tooltip>
              </span>
            )}
          </Typography>
        </Grid>
        <Grid item>
          <Typography className={classes.optional} variant="subtitle1">
            {!required && optionalLabel ? '' : ' '}
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
}
